import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import StarRating from "../../../components/common/StarRating";

const TopicsCustomers = ({ topTerms }) => {
  const { t } = useTranslation();

  const [selectedTopicIndex, setSelectedTopicIndex] = useState(0);
  const [selectedTopic, setSelectedTopic] = useState({});

  useEffect(() => {
    if (topTerms?.length > 0) {
      setSelectedTopic(topTerms[0]);
    }
  }, []);

  const getRatingPercentage = (rating) => {
    if (!rating || isNaN(rating)) return 0;
    return Math.round((rating / 5) * 100);
  };

  return (
    <div className="common_col w-50 customer_topics">
      <h2 className="fs_20">{t("Topics customers often mention")}</h2>
      <div className="buttons">
        {topTerms?.map((topic, index) => (
          <button
            key={index}
            className={selectedTopicIndex === index ? "active" : ""}
            onClick={() => {
              setSelectedTopicIndex(index);
              setSelectedTopic(topic);
            }}
          >
            {topic.term}
          </button>
        ))}
      </div>
      <div className="rating_section d-flex ">
        <h2 className="fs_30">{selectedTopic?.avgRating?.toFixed(1)}</h2>
        <div className="w-100 custom_progressbar">
          <ProgressBar now={selectedTopic?.total} />
          <StarRating
            rating={getRatingPercentage(selectedTopic?.avgRating)}
            // starRatedColor={item?.rating > 2 ? "#C4D26E" : "#FF6363"}
          />
        </div>
      </div>
    </div>
  );
};

export default TopicsCustomers;
